import { accOpeningActions, localStateManagementActions,transactionCompositeDataAction  } from '../../../shared/Actions';
import { connect } from 'react-redux';
import MarketPersonalInfoCardComponent from './MarketPersonalInfoCardComponent';

export const mapStateToProps = (state /* , props */) => ({
    accOpeningData: state.accOpeningReducerData,
    initialState: state.loginData,
    masterLookupStateData: state.transactionCompositeDataReducerData,
    localStateData: state.localStateManagementReducerData,
    transactionCompositeData:state.transactionCompositeDataReducerData,
    profileInformationData: state.profileInformationData

});

const mapDispatchToProps = {
    ...accOpeningActions,
    ...localStateManagementActions,
    getCompositeData: transactionCompositeDataAction.getTransactionCompositeData
    
};

export default connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(MarketPersonalInfoCardComponent);
